import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=e9ce1a72&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9ce1a72')) {
      api.createRecord('e9ce1a72', component.options)
    } else {
      api.reload('e9ce1a72', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=e9ce1a72&", function () {
      api.rerender('e9ce1a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21y67tErl5yTr/JS/pricehelp.vue"
export default component.exports